import qs from 'qs';

export const parseQueries = (queries) => qs.parse(queries, { ignoreQueryPrefix: true });

export const getQueriesAsSearch = (queries) =>
  qs.stringify({ ...queries }, { addQueryPrefix: true, arrayFormat: 'repeat' });